

































import { defineComponent } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-ad-compliance-info';
export default defineComponent({
  name,
  components: { ALink },
  props: {
    is1nn: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      name,
    };
  },
});
